import Axios from "axios";
import {
  SET_PRODUCTION_BUNDLE_LIST,
  UNSET_PRODUCTION_BUNDLE_LIST,
} from "@/store/mutation-types";
import { bundleResource } from "@/store/api";

// Initial State
const state = {
  getProductionBundleList: [],
};

// Getters
const getters = {
  getProductionBundleList(state) {
    return state.getProductionBundleList;
  },
};

// Mutations
const mutations = {
  [SET_PRODUCTION_BUNDLE_LIST](state, data) {
    state.getProductionBundleList = data;
  },
  [UNSET_PRODUCTION_BUNDLE_LIST](state) {
    state.getProductionBundleList = [];
  },
};

// Actions
const actions = {
  // GET LIST
  getProductionBundleList({ commit }) {
    return new Promise((resolve, reject) => {
      Axios.get(bundleResource)
        .then((response) => {
          commit(SET_PRODUCTION_BUNDLE_LIST, response.data.data);
          resolve(response);
        })
        .catch((error) => {
          commit(UNSET_PRODUCTION_BUNDLE_LIST);
          reject(error);
        });
    });
  },

  // CREATE
  saveProductionBundle({ commit }, data) {
    commit("SET_LOADING", { color: "primary" });
    return new Promise((resolve, reject) => {
      Axios.post(bundleResource, data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },

  // UPDATE
  updateProductionBundle({ commit }, { id, data }) {
    commit("SET_LOADING", { color: "primary" });
    const url = `${bundleResource}/${id}`;

    return new Promise((resolve, reject) => {
      Axios.put(url, data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },

  // GET BY ID
  getProductionBundleById({ commit }, id) {
    return new Promise((resolve, reject) => {
      const url = `${bundleResource}/${id}`;
      Axios.get(url)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
